import React from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { LOGO_PATH, LOGO_ALT } from "../../../../constants/logo";

const ClientOnlyRestrictedPage = () => {
  const { user, logout, isClientView } = useAuth();
  const navigate = useNavigate();

  if (isClientView()) {
    return <Navigate to="/client-overview" replace />;
  }

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <div className="flex h-screen w-full flex-col">
      <div className="flex h-full w-full flex-wrap items-start bg-default-background mobile:flex-col mobile:flex-wrap mobile:gap-0">
        <div className="flex max-w-[576px] grow shrink-0 basis-0 flex-col items-center gap-12 self-stretch bg-neutral-800 px-12 py-12 mobile:h-auto mobile:w-full mobile:flex-none">
          <div className="flex w-full max-w-[448px] grow shrink-0 basis-0 flex-col items-start justify-center gap-12 mobile:h-auto mobile:w-full mobile:max-w-[448px] mobile:flex-none">
            <img
              alt={LOGO_ALT}
              className="h-8 flex-none object-cover invert"
              src={LOGO_PATH}
            />
            <div className="flex flex-col items-start justify-center gap-16 pb-32 mobile:px-0 mobile:py-0">
              <div className="flex flex-col items-start gap-2">
                <span className="text-heading-2 font-heading-2 text-white">
                  Client area only
                </span>
                <span className="text-heading-3 font-heading-3 text-brand-200">
                  This page is only available when you sign in as a client. Your
                  current account cannot open this screen.
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="flex grow shrink-0 basis-0 flex-col items-center justify-center gap-6 self-stretch border-l border-solid border-neutral-border px-12 py-12">
          <div className="flex w-full max-w-[448px] flex-col items-start justify-center gap-8">
            <div
              className="flex h-14 w-14 items-center justify-center rounded-full bg-neutral-100"
              aria-hidden
            >
              <svg
                className="h-7 w-7 text-neutral-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={1.5}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
                />
              </svg>
            </div>

            <div className="flex flex-col gap-2">
              <h1 className="text-heading-2 font-heading-2 text-default-font">
                Not available for your role
              </h1>
              <p className="text-body font-body text-neutral-500">
                Use the button below to go to Reco in your dashboard, or go back
                to where you were.
              </p>
            </div>

            {user && (
              <div className="w-full rounded-lg border border-neutral-border bg-neutral-50 px-4 py-3">
                <p className="text-sm text-neutral-600">
                  Logged in as{" "}
                  <span className="font-medium text-neutral-800">
                    {user.email}
                  </span>
                  {" · "}
                  <span className="inline-flex items-center rounded bg-neutral-200 px-1.5 py-0.5 text-xs font-medium text-neutral-700">
                    {user.role}
                  </span>
                </p>
              </div>
            )}

            <div className="flex w-full flex-col gap-3 pt-2">
              <Link
                to="/dashboard/reco"
                className="flex items-center justify-center rounded-lg bg-neutral-800 px-4 py-3 text-base font-semibold text-white transition hover:bg-neutral-700 focus:outline-none focus:ring-2 focus:ring-neutral-500 focus:ring-offset-2"
              >
                Go to Reco
              </Link>
              <button
                type="button"
                onClick={handleGoBack}
                className="flex items-center justify-center rounded-lg border border-neutral-border bg-white px-4 py-3 text-base font-semibold text-neutral-700 transition hover:bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-neutral-500 focus:ring-offset-2"
              >
                Go back
              </button>
              <button
                type="button"
                onClick={handleLogout}
                className="flex items-center justify-center rounded-lg border border-transparent px-4 py-3 text-base font-semibold text-neutral-600 transition hover:text-neutral-800 focus:outline-none focus:ring-2 focus:ring-neutral-500 focus:ring-offset-2"
              >
                Log out
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientOnlyRestrictedPage;
